import PropTypes from "prop-types";
import { Dialog } from "components/uikit-adapter/index";
import intl from "react-intl-universal";
import OrdersVolum from "components/orders-pending-volumn";
import { Container, ContainerActions, Header, Title, DateSpan } from "./styled";
import moment from "moment";
import IconDeliveryTruckWithBackground from "components/icons/icn-delivery-truck-with-background.icon";
import Button from "components/button";

const Modal = (props) => {
  const handleClose = () => {
    const { getGrid } = props;
    const history = props.history;
    history.push("/gridVision");
    getGrid();
  };

  return (
    <Dialog
      title={
        <Header>
          <IconDeliveryTruckWithBackground />
          <Title>{intl.get("grid-vision.modal.title")}</Title>
          <DateSpan>{moment(props.match.params.date).format("L")}</DateSpan>
        </Header>
      }
      open={props.match.params.familyId}
      autoScrollBodyContent
      actions={
        <ContainerActions data-testid="btn-orders-volum">
          <Button
            value={intl.get("geral.buttonsDefault.close")}
            onClick={handleClose}
            buttonType="secondary"
            className="buttons"
          />
        </ContainerActions>
      }
    >
      <Container>
        <OrdersVolum {...props} />
      </Container>
    </Dialog>
  );
};

Modal.propTypes = {
  getGrid: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      date: PropTypes.any,
      familyId: PropTypes.any,
    }),
  }).isRequired,
};

export default Modal;
